// extracted by mini-css-extract-plugin
export var cardHeader = "_s6-0";
export var reorderHandle = "_s6-3";
export var titleArea = "_s6-1";
export var titleAreaWithHandle = "_s6-2";